import { useMemo, useState } from "react";
import { Trash2, Search } from "lucide-react";

export function DeletionLog({ deletions }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const inp = "border border-stone-300 bg-white px-3 py-2 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40";
  const filtered = useMemo(() => deletions.filter((d) => {
    if (q) {
      const hay = `${d.company_name || ""} ${d.by_email || ""}`.toLowerCase();
      if (!hay.includes(q.toLowerCase())) return false;
    }
    const day = (d.at || "").slice(0, 10);
    if (from && day < from) return false;
    if (to && day > to) return false;
    return true;
  }), [deletions, q, from, to]);

  if (deletions.length === 0) return null;
  return (
    <div className="bg-white border border-stone-200 rounded-sm overflow-hidden" data-testid="deletion-log">
      <button data-testid="deletion-log-toggle" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-6 py-4 hover:bg-stone-50">
        <span className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-stone-500"><Trash2 size={16} className="text-alert" /> Log eliminazioni aziende ({deletions.length})</span>
        <span className="text-xs text-stone-400">{open ? "Nascondi" : "Mostra"}</span>
      </button>
      {open && (
        <div className="border-t border-stone-100">
          <div className="flex flex-wrap items-center gap-3 px-6 py-3 bg-stone-50/60">
            <div className="relative flex-1 min-w-[200px]">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <input data-testid="deletion-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per azienda o email…" className={`${inp} w-full pl-9`} />
            </div>
            <label className="text-xs text-stone-500 flex items-center gap-2">Dal <input data-testid="deletion-date-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={inp} /></label>
            <label className="text-xs text-stone-500 flex items-center gap-2">Al <input data-testid="deletion-date-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} className={inp} /></label>
            {(q || from || to) && <button data-testid="deletion-clear-filters" onClick={() => { setQ(""); setFrom(""); setTo(""); }} className="text-xs font-semibold text-brand hover:underline">Azzera</button>}
            <span data-testid="deletion-filter-count" className="text-xs text-stone-500">{filtered.length} di {deletions.length}</span>
          </div>
          {filtered.length === 0 ? (
            <p className="px-6 py-6 text-sm text-stone-400">Nessuna eliminazione corrisponde ai filtri.</p>
          ) : (
            <table className="w-full text-sm">
              <thead><tr className="text-xs uppercase tracking-[0.12em] text-stone-500 border-b border-stone-200">
                <th className="text-left font-bold py-3 px-6">Azienda</th><th className="text-left font-bold py-3 px-6">Piano</th>
                <th className="text-left font-bold py-3 px-6">Dati eliminati</th><th className="text-left font-bold py-3 px-6">Eliminata da</th><th className="text-left font-bold py-3 px-6">Quando</th></tr></thead>
              <tbody>
                {filtered.map((d) => (
                  <tr key={d.id} data-testid={`deletion-row-${d.id}`} className="border-b border-stone-100">
                    <td className="py-3 px-6 font-semibold text-stone-800">{d.company_name}</td>
                    <td className="py-3 px-6 text-stone-600">{d.plan || "—"}</td>
                    <td className="py-3 px-6 text-stone-500 text-xs">{d.counts ? `${d.counts.users || 0} utenti · ${d.counts.products || 0} prod · ${d.counts.invoices || 0} fatt · ${d.counts.recipes || 0} ric · ${d.counts.purchase_orders || 0} ord` : "—"}</td>
                    <td className="py-3 px-6 text-stone-600">{d.by_email || "—"}</td>
                    <td className="py-3 px-6 text-stone-500">{new Date(d.at).toLocaleString("it-IT")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
